import { size } from 'lodash'

import api from 'common/api'
import { APP } from 'common/metadata-constants'

export const getLocalApplicationSSORedirectUri = (scid, applId) =>
  `${import.meta.env.BASE_URL}/redirect/appl/${scid}/${applId}/sso`

export const appProfileLinkUrl = `${import.meta.env.BASE_URL}/app-profile`
export const appProfileLinkUrlWithProspectFn = (prospectId) =>
  `${import.meta.env.BASE_URL}/app-profile?prospectId=${prospectId}`

// this is deprecated and should be removed, all links into the App Profile should use the prospectId or not use a query param at all
export const appProfileLinkUrlWithScidFn = (scid) => `${import.meta.env.BASE_URL}/app-profile?scid=${scid}`
export const appProfileOverviewUrl = appProfileLinkUrl
export const freeCollegesUrl = `${import.meta.env.BASE_URL}/discover/for-you/free-apps-with-scoir`

export const learnMoreUrl = 'https://www.scoir.com/students/first-year-applications'

// Verify need of this QP / flag
const getSSOUrl = (scid, applicationId, appCycle) =>
  `/api/colleges/${scid}/integrations/applications/${applicationId}/sso${
    appCycle ? `?applicationCycle=${appCycle}` : ''
  }`

export const fetchPortalLink = async (scid, applicationId, appCycle) => {
  const params = new URLSearchParams({ EventSourceApplication: APP })

  const options = {
    headers: {
      'x-scoir-event-data': params.toString(),
    },
  }

  return api.get(getSSOUrl(scid, applicationId, appCycle), options)
}

const hasInitiated = (status) => {
  const isNotInitiating = status !== 'initiating'
  return isNotInitiating && size(status) > 0
}

export const useFetchPortalLink = ({ scid, appId, status, prospectId }) => {
  const isInitiated = hasInitiated(status)
  return {
    url: isInitiated ? getLocalApplicationSSORedirectUri(scid, appId) : appProfileLinkUrlWithProspectFn(prospectId),
    loading: false,
    isInitiated,
  }
}
